module.exports = __webpack_public_path__ + "img/jingDian-2.842754e6.jpg";